import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import { EncryptStorage } from 'encrypt-storage';
// import axios from 'axios';
// import qs from 'qs';

export const encryptStorage = new EncryptStorage(toString('exposed2024'), {
  storageType: 'localStorage',
  stateManagementUse: true
});

export default createStore({
  state: {
    user: null,
    username: null, 
    avatar: null,
    isVerified: false
  },
  getters: {
  },
  mutations: {
    UPDATE_USER(state, payload){
      state.user = payload
    },
    UPDATE_USERNAME(state, payload){
      state.username = payload
    },
    UPDATE_AVATAR(state, user) {
      state.avatar = user?.avatar || null;
    },
    UPDATE_ISVERIFIED(state, payload) {
      state.isVerified = payload;
    },
  },
  actions: {
    
  },
  modules: {
  },
  plugins: [createPersistedState({ 
    storage: { 
      setItem: (key, state) => encryptStorage.setItem(key, state),
      getItem: (key) => {
        try {
          return encryptStorage.getItem(key);
        } catch (error) {
          console.error('Error reading from local storage:', error);
          localStorage.removeItem(key);
          return null;
        }
      },
      removeItem: (key) => encryptStorage.removeItem(key)
    }
  })],
})
